import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import ProfileSection from "./routes/ProfileSection";
import ProfileV2 from "Platform/routes/ProfileV2";
export default store => {
  return {
    path: "teacher-profile/:teacherId",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "teacher-profile" */ "./components"),
          import(
            /* webpackChunkName: "teacher-profile" */ "Administrator/modules/CommonModule"
          ),
          import(
            /* webpackChunkName: "teacher-profile" */ "TeacherProfile/modules/TeacherProfileModule"
          ),
          import(
            /* webpackChunkName: "teacher-profile" */ "TimetableConfiguration/modules/TimetableConfigurationModule"
          ),
          import(
            /* webpackChunkName: "teacher-profile" */ "TimetablePlanner/modules/TimetablePlannerModule"
          ),
        ]).then(
          ([
            importedModule0,
            importedModule1,
            importedModule2,
            importedModule3,
            importedModule4,
          ]) => {
            const component = importedModule0.default;
            const commonReducerForAdmin = importedModule1;
            const teachrerProfileModule = importedModule2;
            const timeTableReducer = importedModule3;
            const timetablePlannerModule = importedModule4;
            injectReducer(store, {
              key: commonReducerForAdmin.NAME,
              reducer: commonReducerForAdmin.default,
            });
            injectReducer(store, {
              key: timeTableReducer.NAME,
              reducer: timeTableReducer.default,
            });
            injectReducer(store, {
              key: teachrerProfileModule.NAME,
              reducer: teachrerProfileModule.default,
            });
            injectReducer(store, {
              key: timetablePlannerModule.NAME,
              reducer: timetablePlannerModule.default,
            });
            return component;
          }
        )
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [ProfileV2(store), ProfileSection(store)],
  };
};
